/** 1-based row number for admin tables (supports pagination). */
export function rowNumber(index: number, page = 1, pageSize = 0): number {
  if (pageSize > 0 && page > 0) return (page - 1) * pageSize + index + 1;
  return index + 1;
}
